// Sprint 35: the mini-game seed. Pure and browser-safe (WebCrypto only), shared by the server, the page and /verify.
// miniSeed = HMAC-SHA256(shiftSeed, "<round id>:<player>:mini:<game id>"), hex. It reveals nothing about the shift seed.
// The game reads one byte per step from it (seedBytes): a small integer generator, so the page needs no async hash to play.

const enc = new TextEncoder();
const hex = bytes => [...new Uint8Array(bytes)].map(b => b.toString(16).padStart(2, '0')).join('');

export const miniSeedLabel = (roundId, player, gameId) => `${roundId}:${player}:mini:${gameId}`;

export async function miniSeedOf(shiftSeed, roundId, player, gameId) {
  const key = await globalThis.crypto.subtle.importKey('raw', enc.encode(String(shiftSeed)), { name: 'HMAC', hash: 'SHA-256' }, false, ['sign']);
  return hex(await globalThis.crypto.subtle.sign('HMAC', key, enc.encode(miniSeedLabel(roundId, player, gameId))));
}

// sfc32 over the first four 32-bit words of the miniSeed; integer arithmetic only, so every engine agrees.
export function seedBytes(miniSeed, steps) {
  const w = [0, 1, 2, 3].map(i => parseInt(String(miniSeed).slice(i * 8, i * 8 + 8).padEnd(8, '0'), 16) | 0);
  let [a, b, c, d] = w;
  const next = () => {
    const t = (((a + b) | 0) + d) | 0;
    d = (d + 1) | 0;
    a = b ^ (b >>> 9);
    b = (c + (c << 3)) | 0;
    c = (c << 21) | (c >>> 11);
    c = (c + t) | 0;
    return (t >>> 0) & 255;
  };
  for (let i = 0; i < 12; i++) next();
  const out = new Uint8Array(steps);
  for (let i = 0; i < steps; i++) out[i] = next();
  return out;
}
